import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[ZipCode]'
})
export class ZipCodeDirective {
  private regex: RegExp = /^[0-9]*$/;

  constructor(private elementRef: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Backspace') {
      return;
    }
    const inputValue: string = this.elementRef.nativeElement.value.concat(event.key);
    if (inputValue && !String(inputValue).match(this.regex)) {
      event.preventDefault();
    }
    if (inputValue.length > 5) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event) {
    const clipboardData = (event.originalEvent || event).clipboardData.getData('text/plain');
    if (clipboardData) {
      if (!this.regex.test(clipboardData)) {
        event.preventDefault();
      }
    }
  }

  @HostListener('ngModelChange', ['$event']) onInputChange(event) {
    if (event) {
      const inputVal = event.replace(/[^0-9]/g, '').substring(0, 5);
      this.elementRef.nativeElement.value = inputVal;
    }
  }
}


